import { Alert, Col, Container, ToastHeader } from "react-bootstrap"
import { SideNav } from '../../home-page/shared-components/side-nav';

import { Button, Card, IconInfo, Modal, Group, useToast } from "@veneer/core"
import React, { useEffect } from "react"
import { apiPost } from "../../../services/service"
import { POST_PRODUCT_INFO } from "../../../services"
import CaseItems from "@components/home-page/shared-components/case-items/case-items";
import { useSearchParams } from "react-router-dom";
// import { Helmet } from "react-helmet";
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import {
  POST_CREATE_CASE_LOAD,
} from "../../../services";
import "./call-me-back.scss"
import { Trans, useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import Loader from "../shared-components/loader/loader";
interface VeneerWcpThemeProviderProps extends React.HTMLAttributes<HTMLElement> {
    mode: string;
}

interface VeneerWcpLocaleProviderProps extends React.HTMLAttributes<HTMLElement> {
    locale: string;
}

declare global {
  namespace JSX {
    interface IntrinsicElements {
        'myaccount-phone-widget': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>;
        'myaccount-locale-override': VeneerWcpLocaleProviderProps;
        'veneer-wcp-theme-provider': VeneerWcpThemeProviderProps;
    }
  }
}


export const CallMeBack = () => {
  const [getProductInfo, setProductInfo] = React.useState<any>([]);
  const [pageLoad, setPageLoad] = React.useState<any>([]);
  const [userName, setUserName] = React.useState<any>("");
  const [userEmail, setUserEmail] = React.useState<any>("");
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const [showModal, setShowModal] = React.useState<boolean>(false);
  const [showCallbackExistsModal, setShowCallbackExistsModal] = React.useState<boolean>(false);
  const [progress, setProgress] = React.useState<boolean>(false);
    const path = window.location.pathname.split('/')[1].split('-');
    const language = path[0] + "_" + path[1].toUpperCase();

  const styles = {
    style: {
      marginTop: '8px',
      marginBottom: '8px',
      display: 'block',
      verticalAlign: 'middle'
    }
  };

  const { addToast } = useToast();
  const addToastHandler = (title: string): void => {
    addToast({
      text: title,
      type: 'negative',
      timeout: 30,
      id: 1,
      subtitle: "Description",
      action: <Button small appearance="ghost">Action</Button>
    });
  };

  useEffect(() => {
    setUserName((window as any).username ? (window as any).username : "Firstname lastname")
    setUserEmail((window as any).email ? (window as any).email : "welcome@hp.com")
    async function fetchMyAPI() {
      // var FallBackURL = "myaccount-phone-widget";
      var headerscript = document.createElement('script');
      headerscript.setAttribute('locale', 'en_US');
      const el = document.querySelector('myaccount-phone-widget');
      (document.querySelector('myaccount-phone-widget') as any).locale = window.location.pathname.split('/')[1].replace('-', '_');
      (document.querySelector('myaccount-phone-widget') as any).required= true;
      if (el)
        el.setAttribute("locale", "en_US")
      // el.setAttribute("locale","en-US");
      // console.log(el)
      // $('myaccount-phone-widget').ready(function () {
      //     document.querySelector('myaccount-phone-widget').required = true;
      //     $('myaccount-phone-widget').on('input', function () {
      //         $("#verifyError").css("display", "none");
      //     });
      // });


      const payloadpageload = {
        contactid: "85680c15-7814-e711-80fc-5065f38ad971",
        accountid: "f16eeb64-73fc-e611-80fa-5065f38ad971",
      };
      
      try {
        setProgress(true);
        const pageloadres: any = await apiPost(
          POST_CREATE_CASE_LOAD,
          payloadpageload
        );
        if (pageloadres.data) {
          setPageLoad(pageloadres.data);
          setProgress(false);
        }
        const payload = {
          ainfo: searchParams.get("ainfo"),
          pinfo: searchParams.get("pinfo"),
          pno: searchParams.get("pno"),
          contactid: "85680C15-7814-E711-80FC-5065F38AD971",
          
          
        };
        setProgress(true);
        const productInfo: any = await apiPost(POST_PRODUCT_INFO, payload);
        if (productInfo.data) {
          setProductInfo(productInfo.data);
          setProgress(false);
          //   setISResponse(JSON.parse(productInfo.data?.ISResponse));
        }
      } catch (error) {
        console.error("Error fetching recent cases:", error);
        setProgress(false);
      }
    }
    fetchMyAPI()
  }, [])


  const handleChangeSubmit = async () => {
    if (!getProductInfo || getProductInfo.length === 0) {
      toast.error(t('HPI.ErrorMessage.ProductInformationNotFound',{defaultValue:'Product information not found'}));
      return;
    }
    const ProductInfo = JSON.parse(getProductInfo.ISResponse);
    const productNumber = ProductInfo[0]?.Assets[0]?.Product.ProductId;
    const serialNumber = ProductInfo[0]?.Assets[0]?.AssertSerialNumber;
    const widget = document.querySelector('myaccount-phone-widget') as any;
    const verifiedPhoneNumber = widget ? `${widget.primaryPhone.countryCode}${widget.primaryPhone.number}`:'';
    console.log("verifiedPhoneNumber", verifiedPhoneNumber);

    try {
        if (widget.primaryPhone.verified === true) {

        const payload = {
          callbackusername: userName,
          callbacknumbers: verifiedPhoneNumber,
          wcb_email: userEmail,
          wcb_serialnumber: serialNumber,
          wcb_productnumber: productNumber,
          caseGUID: new URLSearchParams(window.location.search).get('cid')
        };
        setProgress(true);
        document.body.classList.add("scroll-bar");
        const callBackResp = await apiPost("/customerportal/callmeback/v1/btnSubmitCallback_Click", payload);
          if (callBackResp.message !== undefined && callBackResp.message !== null && callBackResp.message !== "") {
              toast.error(callBackResp.message);
              setProgress(false);
              return;
          } else if (callBackResp.data.success == true) {
              if (!callBackResp.data.isHpIdVerified) {
                  console.log(callBackResp.data.isHpIdVerified);
                  toast.error("Phone number is not verified");
              }
              else if (callBackResp.data.isHpIdVerified) {
                  if (callBackResp.data.callback.callbackExists == true) {
                      setShowCallbackExistsModal(true);
                  }
                  console.log(callBackResp.data.isHpIdVerified);
                  setShowModal(true);
              }
          }
          else {
              toast.error(callBackResp.data.HpIdresponce);
          }
      } else {
        toast.error(t('HPI.ErrorMessage.SomethingWentWrongTryAgain',{defaultValue:'Something went Wrong.. please try again after some time'}));
      }
      setProgress(false);
    } catch (error) {
      console.log("error", error);
      setProgress(false);
    }
    
  };


  const handelChangeOk = () => {
    document.body.classList.remove("scroll-bar");
    setShowModal(false);
    setShowCallbackExistsModal(false);
  };


  const handleBack = async () => {
    document.body.classList.remove("scroll-bar");
    navigate(`/edit-case/?cid=${searchParams.get("cid")}`)
  }


  return (
    <>
      <div>
        {progress && (
          <div className="loader-overlay">
            <div className="loader-css">
              <Loader />
            </div>
          </div>
        )}
        <Container fluid className="bg-clr">
          <SideNav />
          <div className="callMeBack">
            <div className="header">
              <h2>{t('HPI.EditCase.Case.HPCallMe',{defaultValue:'Call me back'})}</h2>
              <Col className="supporting-text">
                <p className="label-regular">
                  {t('HPI.CallMeForm.SectionHeading',{defaultValue:'One last step. Our agents need a little more information.'})}
                </p>
                <span>
                  <strong style={{ color: "red" }}>*</strong> {t('HPI.CallMeForm.RequiredFields',{defaultValue:'Required fields'})}
                </span>
              </Col>
            </div>
            <Container className="card-container">
              <CaseItems
                data={getProductInfo}
                selectedcasepriority={pageLoad?.selectedcasepriority}
              />
            </Container>
            <Container className="card-container mt-5">
          <div className="cord-details2" >
            <Container className="card-container-mobile" >
              <div className="contact_head">
                <h4>
                  {t("HPI.CallMeForm.FormHeading", {
                    defaultValue: "Contact Information",
                  })}
                </h4>
              </div>

              <div className="sub_txt">
                <h6>{t("HPI.CallMeForm.Name", { defaultValue: "Name" })}:{" "}
                  {(window as any).username
                    ? <span dangerouslySetInnerHTML={{ __html: (window as any).username }}></span>
                    : "Firstname lastname"}</h6>
              </div>
              <div className="sub_txt">
                <h6>{t("HPI.CallMeForm.Email", { defaultValue: "Email" })}:{" "}
                  {(window as any).email
                    ? (window as any).email
                    : "welcome@hp.com"}</h6>
              </div>
              <hr style={{ border: 'none', borderTop: '1.5px solid #ccc', margin: '12px 0' }} />
              <div className="hpid_head">
                <Helmet >
                  <script type="module" src={(window as any).hpidWidgetURL}></script>
                  {/* <script type="module" src="https://account.stg.cd.id.hp.com/webcomponents/phone-widget/myaccount-phone-widget.js"></script> */}
                </Helmet>
                <myaccount-locale-override locale={language}></myaccount-locale-override>
                <veneer-wcp-theme-provider mode="light">
                  <myaccount-phone-widget style={styles.style}></myaccount-phone-widget>
                </veneer-wcp-theme-provider>
              </div>
              <div className="des_statement">
                <IconInfo size={20} filled color="#666" />
                {t("HPI.CallMeForm.NumberAlert", {
                  defaultValue:
                    "Changing the phone number is changing the HPID phone number.",
                })}
              </div>
            </Container>
        
          </div>
  
        </Container>

        <div className="footer">
                <div className="row align-items-start">
                  <div className="col-md-8 left-sec">
                    <p>
                      <div className="footer_info">
                        <span>
                          {t('HPI.CallMeForm.PrivacyText',{defaultValue:`By completing and submitting this form you consent to the use of your data in accordance with HP's Privacy statement.`})}
                        </span>
                        <a href="https://www.hp.com/us-en/privacy/privacy.html">
                          {t('HPI.CallMeForm.PrivacyLinkText',{defaultValue:`Learn more about HP's privacy statement.`})}
                        </a>
                      </div>
                    </p>
                  </div>
                  <div className="button-box col-md-4">
                    <Button className="btn-cancel" id="btn-cancel" appearance="secondary" onClick={handleBack}>
                      {t('HPI.CallMeForm.ContactOptions',{defaultValue:'Back to case details'})}
                    </Button>
                    <Button
                      type="submit"
                      id="btn-next"
                      onClick={handleChangeSubmit}
                    >
                      {t('HPI.CallMeForm.Submit',{defaultValue:'Submit'})}
                    </Button>
                  </div>
                </div>
              </div>
          </div>
        
        </Container>

        
        
         
        
        
      </div>
      <div style={{ position: 'relative' }}>
        <Modal
          customStyle={"overflow:auto !important;"} 
          align="center"
          show={showModal}
          footer={(
            <Group>
              <Button
                onClick={handleBack}
              >{t('HPI.CallMeForm.ContactOptions',{defaultValue:'Back to case details'})}</Button>
            </Group>
          )}
        >
          <h4 className="subtitle-large">{t('HPI.CallMeForm.Confirmation.SuccessHeading',{defaultValue:'Callback request has been submitted, an agent will be with you shortly'})}</h4>
          <div id="modeltext1" >
            <h5 className="body-large">{t('HPI.CallMeForm.Confirmation.TimeText',{defaultValue:'Expect your call within the next'})} :</h5>
            <h6 >{t('HPI.CallMeForm.Confirmation.TimeMinutes',{defaultValue:'15 minutes'})}</h6>
          </div>
          <p className="body-large">
            {t('HPI.CallMeForm.Confirmation.AgentCalls',{defaultValue:'Please make sure you are available to answer when the agent calls.'})}
          </p>
        </Modal>
        <Modal
          align="center"
          show={showCallbackExistsModal}
          customStyle={"overflow:auto !important;"} // Added max-height to prevent hiding the scroll bar
          footer={(
            <Group>
              <Button
          onClick={handleBack}
              >{t('HPI.CallMeForm.ContactOptions',{defaultValue:'Back to case details'})}</Button>
            </Group>
          )}
        >
          <h4 className="subtitle-large">{t('HPI.CallMeForm.Confirmation.PendingHeading',{defaultValue:'The callback request is already in the queue, an agent will be with you shortly'})}</h4>
          <p className="body-large">
            {t('HPI.CallMeForm.Confirmation.AgentCalls',{defaultValue:'Please make sure you are available to answer when the agent calls.'})}
          </p>
        </Modal>
      </div>
    </>
  );
};